import { styled } from '@linaria/react';
export var VisuallyHidden = /*#__PURE__*/styled("div")({
  name: "VisuallyHidden",
  class: "v1qjg41g"
});

require("../../../apps/tv/.linaria-cache/packages/@webtv/shared-ui/VisuallyHidden.linaria.module.css");